import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  currentInstallerHammerRatingCount,
  ExtendedHammerRatingDetails,
  InstallationTypeSubtypesClaimed,
} from '../../../../core/installer-profile';
import { vtiDialImagePath, vtiRankFromRating } from '../../../../shared/charts/utils/vti-rank';
import { completedYearsSince } from '../../../../shared/utils/experience-years';

@Component({
  selector: 'gc-installer-vti-details',
  templateUrl: './installer-vti-details.component.html',
  styleUrls: ['./installer-vti-details.component.scss'],
})
export class InstallerVtiDetailsComponent {
  @Input() hammerRatingsDetails!: ExtendedHammerRatingDetails[];

  /** The installer's discipline claims, which carry the date they started in each. */
  @Input() claims: InstallationTypeSubtypesClaimed[] = [];

  hammerRatingCount$ = this.store.select(currentInstallerHammerRatingCount);

  constructor(private readonly store: Store) {}

  /**
   * TT-273: the backend's VTI bands, the same ones the VTI profile uses. The
   * dial used to be cut in eighths of the old 0-5 hammer scale, which put a VTI
   * of 0.53 at Rookie here and Intermediate on the VTI.
   */
  getDialImgPathByRating = vtiDialImagePath;

  getRankName = vtiRankFromRating;

  /**
   * TT-273: years in this discipline, under its dial. Only for a verified
   * claim, the same rule as the badge's "Installing Floors Since", so the
   * profile never states experience nobody has checked. null hides the line.
   */
  yearsFor(productInstallationTypeId: number): number | null {
    const claim = this.claims?.find(
      c => c.installTypeClaimed?.productInstallationTypeId === productInstallationTypeId,
    )?.installTypeClaimed;
    return claim?.isVerified ? completedYearsSince(claim.dateClaimed) : null;
  }
}
